import { PLAYGROUND_PAGES } from "../../constants";
import { Box, Stack, Typography } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import { maxWidthConfig } from "@/theme";
import { useEffect, createElement } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import PlaygroundHeader from "../../components/PlaygroundHeader";
import PlaygroundPageList from "../../components/PlaygroundPageList";

export default function PlaygroundPage({
  changeMaxWidth,
}: {
  changeMaxWidth: (arg: string) => void;
}) {
  const navigate = useNavigate();

  useEffect(() => {
    changeMaxWidth(maxWidthConfig.playgroundMaxWidth);
    return () => {
      changeMaxWidth(maxWidthConfig.defaultMaxWidth);
    };
  }, []);

  const pages = PLAYGROUND_PAGES;

  return (
    <>
      <Routes>
        <Route
          path=""
          element={
            <Box sx={{ py: 2 }}>
              <PlaygroundHeader
                pages={pages}
                pageName="Home"
                shouldShowBackButton={false}
              />
              <PlaygroundPageList pages={pages} />
            </Box>
          }
        />
        {pages &&
          pages.map((page) => {
            const pageName = page.name;
            return (
              <Route
                key={pageName}
                path={pageName}
                element={
                  <Stack spacing={2} p={0} sx={{ minHeight: "100%" }}>
                    {page.showHeader !== false && (
                      <PlaygroundHeader pages={pages} pageName={pageName} />
                    )}
                    <Stack px={page.includePadding === false ? 0 : 2}>
                      {createElement(page.component)}
                    </Stack>
                  </Stack>
                }
              />
            );
          })}
        <Route
          path="*"
          element={
            <>
              <CircledBackButton onClick={() => navigate("/playground")} />
              <Typography variant="h2">
                Whoops, couldn't find that component's examples
              </Typography>
            </>
          }
        />
      </Routes>
    </>
  );
}
